import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ type = 'info', message, className = '' }) => {
  if (!message) return null;

  const baseClasses = 'p-3 rounded-md text-sm';
  let typeClasses = '';

  switch (type) {
    case 'success':
      typeClasses = 'bg-green-100 text-green-700';
      break;
    case 'error':
      typeClasses = 'bg-red-100 text-red-700';
      break;
    case 'warning':
      typeClasses = 'bg-yellow-100 text-yellow-700';
      break;
    default: // info
      typeClasses = 'bg-blue-100 text-blue-700';
  }

  return (
    <div className={`${baseClasses} ${typeClasses} ${className}`} role="alert">
      {message}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  message: PropTypes.string,
  className: PropTypes.string,
};

export default Alert;